<template>
  <div v-if="product">
    <Navbar />
    <ProductBanner :product="product" />
    <ProductModules :product="product" />
    <Footer />
    <WhatsAppFloat />
  </div>
</template>

<script>
import Navbar from '../Layouts/Navbar'
import Footer from '../Layouts/Footer'
import WhatsAppFloat from '../Common/WhatsAppFloat'
import ProductBanner from '../products/ProductBanner'
import ProductModules from '../products/ProductModules'
import { getProduct } from '../../data/products'

export default {
  name: 'ProductPage',
  components: {
    Navbar,
    Footer,
    WhatsAppFloat,
    ProductBanner,
    ProductModules,
  },
  computed: {
    product() {
      const slug = this.$route.meta.productSlug
      return getProduct(slug)
    },
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  watch: {
    '$route.fullPath'() {
      window.scrollTo(0, 0)
    },
  },
}
</script>
